import { useState } from 'react';
import { Button, CircularProgress, Paper, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

type Props = {
  isSubmitting: boolean;
  onCreate: (name: string) => Promise<boolean>;
};

const useStyles = makeStyles((theme) => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    padding: '1rem 0.75rem',
  },
  createButton: {
    alignSelf: 'flex-end',
    backgroundColor: theme.palette.admin.primary.main,
    color: theme.palette.admin.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.admin.primary.dark,
    },
  },
}));

export function CreateTagCard({ isSubmitting, onCreate }: Props) {
  const classes = useStyles();

  const [name, setName] = useState('');
  const [isPending, setIsPending] = useState(false);

  const trimmedName = name.trim();
  const isBusy = isSubmitting || isPending;
  const canCreate = !isBusy && trimmedName !== '';

  const handleCreate = async () => {
    if (!canCreate) return;

    setIsPending(true);
    try {
      const isCreated = await onCreate(trimmedName);
      if (isCreated) setName('');
    } finally {
      setIsPending(false);
    }
  };

  return (
    <Paper className={classes.card}>
      <TextField
        size="small"
        variant="outlined"
        fullWidth
        id="create-tag-name"
        label="Nom du tag"
        value={name}
        onChange={(event) => setName(event.target.value)}
        helperText='Le préfixe "Tags." et le slug sont ajoutés automatiquement.'
      />
      <Button
        size="small"
        variant="contained"
        className={classes.createButton}
        disabled={!canCreate}
        startIcon={isBusy ? <CircularProgress size={16} /> : null}
        onClick={handleCreate}
      >
        Créer
      </Button>
    </Paper>
  );
}
